/**
 * Mar 3, 2026 · Article number helpers.
 *
 * Article Master stores TWO identifiers per row:
 *   article_no      — the short "base" number the shop floor calls it
 *                     (e.g. "10712"). Non-unique across colours/sizes.
 *   product_code  — the FULL technical Product Code, unique per row
 *                     (e.g. "RNJ/35/10712/04-NIKE-VOLT/WHITE-I").
 *
 * When an SO / ESO / Prod line is created, `line.article_no` is populated
 * from `product_code` (the FULL string) — that's the authoritative
 * manufacturing reference. This helper strips the middle numeric token so
 * reports can show just "10712" in the Article column while keeping the
 * full string for the Product Code column.
 *
 * Rules:
 *   • Splits on `/`. When there are ≥ 3 tokens, returns the 3rd (index 2)
 *     — that's the base article number in the RNJ/38/10712/… convention.
 *   • For strings without `/` (already-base numbers like "10712"), returns
 *     the input untouched.
 *   • Never throws — always returns a string. Blank → blank.
 */
export function baseArticle(v) {
  const s = String(v ?? "").trim();
  if (!s) return "";
  if (s.indexOf("/") === -1) return s;
  const parts = s.split("/");
  return (parts[2] || parts[0] || s).trim();
}

export default baseArticle;
